import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/partners/useReferralQueryKeys.ts
var t = e("referral", { linkInfo: (e) => ["link-info", e] });
//#endregion
export { t as referralQueryKeys };
